/**
 * period.js — muaji i aplikimit, i shkruar në një vend të vetëm.
 *
 * Periudha e një rregullimi page vendos se cila listë page e merr shumën —
 * data nuk është dekor. `getMonthAdjustments` te serveri filtron pikërisht mbi
 * `period_year` / `period_month`, ndaj etiketa këtu duhet të tregojë të njëjtin
 * muaj që do të marrë paga.
 *
 * Rri si util e jo brenda një faqeje sepse periudhat shfaqen edhe te lista e
 * pagave edhe te rregullimet, dhe të dyja duhet ta lexojnë njësoj.
 */

export const MONTHS_SQ = [
  'Janar', 'Shkurt', 'Mars', 'Prill', 'Maj', 'Qershor',
  'Korrik', 'Gusht', 'Shtator', 'Tetor', 'Nëntor', 'Dhjetor',
];

/**
 * Pjesët e datës pa kaluar nga `new Date()`.
 *
 * Backend-i i kthen datat si varg 'YYYY-MM-DD' (db.js e çregjistron parser-in e
 * tipit 1082). `new Date('2026-08-01')` e lexon si UTC mesnatë, dhe në një zonë
 * kohore pas Greenwich-it `getMonth()` kthen muajin e mëparshëm — një bonus i
 * 1 gushtit do të dukej i korrikut. Prandaj vargu ndahet, nuk analizohet.
 */
function parts(value) {
  if (!value) return null;
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return { year: Number(m[1]), month: Number(m[2]) };
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : { year: d.getFullYear(), month: d.getMonth() + 1 };
}

/** '2026-08-15' → 'Gusht 2026'. Pa datë → null, që thirrësi ta trajtojë vetë. */
export function periodLabel(value) {
  const p = parts(value);
  return p ? `${MONTHS_SQ[p.month - 1]} ${p.year}` : null;
}

/** '2026-08-15' → '2026-08'. Çelës i renditshëm për filtra e grupime. */
export function periodKey(value) {
  const p = parts(value);
  return p ? `${p.year}-${String(p.month).padStart(2, '0')}` : '';
}

/**
 * Periudhat e pranishme te rreshtat, nga më e reja te më e vjetra.
 * @param {Array} rows
 * @param {string} dateField — 'bonusDate' | 'advanceDate' | 'receiptDate'
 */
export function periodOptions(rows, dateField) {
  const keys = new Set();
  rows.forEach((r) => { const k = periodKey(r[dateField]); if (k) keys.add(k); });
  return Array.from(keys)
    .sort((a, b) => b.localeCompare(a))
    .map((key) => {
      const [y, m] = key.split('-');
      return { key, label: `${MONTHS_SQ[Number(m) - 1]} ${y}` };
    });
}
